export const hasNumber = (value?: string) => /\d/.test(value ?? '');
export const hasSymbol = (value?: string) =>
  /[!@#$%^&*(),.?":{}|<>_\-+=~`[\]\\;/]/.test(value ?? '');

export const hasObviousSequence = (value?: string) => {
  if (!value) return false;
  const v = value.toLowerCase();

  const sequences = [
    '1234',
    '12345',
    'abcd',
    'qwerty',
    'password',
    'admin',
    'contraseña',
  ];

  return sequences.some((seq) => v.includes(seq));
};
